import PropTypes from 'prop-types';

function IFMeatAndSeafoodInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11290)">
                <path
                    d="M27.7905 7.05007C27.8393 6.3277 27.9705 3.48674 25.9069 2.18181C23.8433 0.876888 17.6269 0.451999 13.6499 2.95341C9.6728 5.45483 10.0601 10.2763 12.673 12.9874C14.6824 15.0928 17.0245 16.8532 19.6056 18.198C22.5884 19.7983 25.7797 20.8024 27.3785 20.3077C28.9773 19.813 31.1346 18.4789 30.0733 15.4097C29.6093 14.3488 28.4984 13.6252 27.9192 12.4474C27.34 11.2696 27.6506 9.01584 27.7905 7.05007Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.0422 8.71008C26.0912 8.12523 26.742 4.85534 24.946 3.66104C23.1499 2.46675 17.7809 2.43804 14.6837 4.20291C11.5866 5.96779 11.9426 9.92127 14.2837 12.3022C16.6249 14.6832 18.5467 15.7414 20.2737 16.757C22.8492 18.2591 24.855 18.9199 26.2999 18.8012C27.5968 18.6921 29.3191 17.7472 28.4719 15.6138C28.0967 14.6777 27.0674 14.0563 26.5062 13.0567C25.9449 12.0571 25.8904 10.5125 26.0422 8.71008Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.4559 5.68413C23.8225 5.43134 24.0968 6.838 23.1126 7.12584C21.2955 7.66001 20.5073 7.72691 20.0489 7.92688C19.4685 8.17989 19.0781 9.17573 22.5051 12.7319C23.9711 14.253 25.3653 15.5487 24.6677 16.1606C24.1344 16.6308 22.5551 15.1418 20.6888 13.1088C17.6825 9.82575 18.5661 8.95112 17.6026 8.83901C16.6392 8.7269 14.7369 9.62318 14.407 8.48398C14.2254 7.82639 14.6727 7.60443 17.1535 6.87597C18.8971 6.37906 20.6674 5.98114 22.4559 5.68413V5.68413Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.80427 13.4984C3.44892 13.0364 8.39561 10.6204 12.6042 12.8296C16.8128 15.0389 18.4968 17.6455 19.7011 21.5908C21.955 20.8253 24.0681 20.8032 26.2748 23.4272C24.8772 22.9838 22.5873 24.2306 21.7972 25.4432C20.8485 26.8764 21.1115 28.4966 22.0212 30.2815C19.7608 29.8167 17.086 28.4308 17.6571 25.047C15.7957 25.9506 13.7034 26.2663 11.6583 25.9523C9.61309 25.6383 7.71187 24.7095 6.20719 23.2892C1.78314 19.1834 2.80427 13.4984 2.80427 13.4984Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.83167 11.9843C10.7598 11.705 11.7015 11.4728 12.6531 11.2883C14.2077 10.9824 16.3589 12.257 17.6658 13.4848C18.9728 14.7126 19.8267 15.6923 19.899 16.151C19.9713 16.6097 18.9191 19.1077 18.9191 19.1077C18.9191 19.1077 17.0593 15.3451 14.3887 13.8892C12.951 13.075 11.4211 12.4355 9.83167 11.9843V11.9843Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.46331 21.2002C4.89655 21.1445 7.4689 21.1129 9.86885 18.473C12.2688 15.8332 11.3072 12.4642 11.3072 12.4642C11.3072 12.4642 7.49015 10.8993 2.80425 13.4982C2.12999 17.5709 4.46331 21.2002 4.46331 21.2002Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.65942 15.363C8.00301 15.4027 8.31373 15.1564 8.35343 14.8128C8.39314 14.4692 8.14679 14.1585 7.80321 14.1188C7.45962 14.0791 7.1489 14.3254 7.1092 14.669C7.06949 15.0126 7.31584 15.3233 7.65942 15.363Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.195 16.1478C11.195 16.1478 13.2413 17.0421 13.569 20.3731C10.4675 21.765 8.37556 19.8081 8.37556 19.8081C8.37556 19.8081 9.7856 19.466 11.195 16.1478Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.9636 18.4215C16.6029 18.9888 15.8539 20.3197 15.1548 20.1684C15.6811 20.8323 14.987 22.1969 14.0364 22.0871C14.1392 22.2599 14.1916 22.4581 14.1876 22.6591C14.1837 22.8602 14.1235 23.0561 14.014 23.2248C13.9045 23.3934 13.7499 23.5281 13.5678 23.6134C13.3858 23.6988 13.1834 23.7316 12.9837 23.7079"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1551 20.4468C17.7615 20.9593 17.0454 22.345 16.1755 22.1465C16.5791 22.8902 16.0165 23.9294 15.1229 23.7674"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11290">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.303711)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFMeatAndSeafoodInactive;

IFMeatAndSeafoodInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFMeatAndSeafoodInactive.defaultProps = {
    className: null,
    width: 28,
};
